import * as classNames from 'classnames';
import * as moment from 'moment';
import * as React from 'react';
import { InfoWindow } from "react-google-maps";
import * as DTOS from "../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../actions/dashboard.actions";
import * as MapActionCreators from "../../../actions/map.actions";
import PlotBadgeContainer from '../../Data/Plot/PlotBadgeContainer';
import { ContinuousSpanStringBuilder } from '../../../helpers/graphHelper';


type PlotSummaryProps = {
    dateFormat: string;
    plotSummary: DTOS.PlotSummary;
    plot: DTOS.Plot;
    userMonitoring: boolean;
}

type PlotSummaryActions = {
    flagPlot: typeof DashboardActionCreators.flagPlotRequest,
    toggleMarkerPopup: typeof MapActionCreators.toggleMarkerPopupRequest;
}

type PlotSummaryAllProps = PlotSummaryProps & PlotSummaryActions;

class PlotSummary extends React.PureComponent<PlotSummaryAllProps, any> {
    constructor(props: PlotSummaryAllProps) {
        super(props);
    }

    render() {

        let { plotSummary, plot } = this.props;

        /*const badgeStatus = plot.plotStatus && plot.plotStatus.code == PlatypusPlotStatus.ACTIVE ? <div className="badge badge-success ml-1">{this.props.referencePlotStatuses ? this.props.referencePlotStatuses.find(p => p.code === "ACTIVE").label : undefined}</div>
            : plot.plotStatus && plot.plotStatus.code == PlatypusPlotStatus.INACTIVE ? <div className="badge badge-danger ml-1">{this.props.referencePlotStatuses ? this.props.referencePlotStatuses.find(p => p.code === "INACTIVE").label : undefined}</div>
                : plot.plotStatus && plot.plotStatus.code == PlatypusPlotStatus.EVALUATING ? <div className="badge badge-info ml-1">{this.props.referencePlotStatuses ? this.props.referencePlotStatuses.find(p => p.code === "EVALUATING").label : undefined}</div>
                    : undefined*/

        const statusBadge = <PlotBadgeContainer
            currentPlot={plot}
        />

        const badges = <span className="pull-right">
            {statusBadge}
            {plot.private ? <div className={classNames("badge ml-1", { "badge-dark": plot.private })}>Private</div> : undefined}
            {this.props.userMonitoring ? <div className={classNames("badge badge-dark ml-1")}>Monitoring</div> : undefined}
        </span>;

        const plotSummaryBox = plotSummary ? <div>
            {plotSummary.years && plotSummary.years.length > 0 ? <div className="mb-1"><strong>Years:</strong> {ContinuousSpanStringBuilder(plotSummary.years)}</div> : undefined}
            {plot.endDate ? <div className="mb-1"><strong>Last Scan:</strong> {plotSummary.lastPlotEvent ? moment(plotSummary.lastPlotEvent).format(this.props.dateFormat) : 'Never'}</div> : undefined}
            {plotSummary.participantCount > 0 ? <div className="mb-1"><strong>Participants:</strong> {plotSummary.participantCount}</div> : undefined}
            {plotSummary.primaryValue && plotSummary.primaryValue.value > 0 ? <div className="mb-1"><strong>{plotSummary.primaryValue.label}:</strong>  {plotSummary.primaryValue.value}</div> : undefined}
            {plotSummary.plotEventCount > 0 ? <div className="mb-1"><strong>Total Scans:</strong> {plotSummary.plotEventCount}</div> : undefined}
            {plotSummary.plotEventCount > 0 ? <div className="mb-1"><strong>Average Sightings/Scan:</strong> {plotSummary.plotEventCount > 120 ? (plotSummary.primaryValue.value / plotSummary.plotEventCount).toFixed(2) : (plotSummary.primaryValue.value / plotSummary.plotEventCount).toFixed(1)}</div> : undefined}
        </div> : undefined;

        return <InfoWindow onCloseClick={() => this.props.toggleMarkerPopup(plot.id)}>
            <div className="card card-data-marker card-plot" style={{ /*marginLeft: "20px"*/ }}>
                <div className="card-header">
                    {badges}
                    <h6>{plot.name}</h6>
                </div>
                <div className="card-body px-2 py-0 pt-2">
                    <div>
                        <div className="mb-1"><strong>Nearest Town/Suburb: </strong>{plot.nearestSuburb ? plot.nearestSuburb : 'Unknown'}</div>
                        <div className="mb-1"><strong>Water Body: </strong>{plot.waterBody ? plot.waterBody : 'Unknown'}</div>
                    </div>
                    <hr />
                    {plotSummaryBox}
                </div>
                <div className="btn-group btn-block mt-2">
                    {/*this.props.enablePlotRegistration && !this.props.userMonitoring ?
                        <button className="btn btn-sm btn-primary"
                            onClick={this.props.flagPlot.bind(this, plot)}>
                            Select Monitoring Site
                        </button> : undefined*/
                    }
                    {this.props.children}
                </div>
            </div>
        </InfoWindow>
    }
}

export default PlotSummary;